import '../../scss/critical.scss';
// import {paApp} from '../paApp';
// paApp.initCritical();


//////////////////
// WEBPACK FOOTER
// ./src/js/framework/paCritical.js
// module id = 32
// module chunks = 1